import React, { useState, useEffect, useRef } from 'react';
import baseURL from '../../Components/url';
import NavbarWorker from '../../Components/Worker/NavbarWorker/NavbarWorker';
import moneda from '../../Components/moneda';
import { useData } from '../../Components/DataContext';
import { useCaja } from '../../Components/Worker/CajaContext';
import { usePlan } from '../../Components/PlanContext';
import { obtenerEstados } from '../../Components/estados';
import { colorTema } from '../../Components/ThemeContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import VERSION from '../../Components/version';
import './WorkerPedidos.css';

export default function WorkerPedidos() {
    const { mesas, loading: mesasLoading, cargarMesas, metodos } = useData();
    const { refrescarCaja } = useCaja();
    const { isPlus, esTienda, tipoNegocio } = usePlan();
    const [pedidos, setPedidos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [busqueda, setBusqueda] = useState('');

    useEffect(() => {
        cargarPedidos();
    }, []);

    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidosMesaGet.php`)
            .then(r => r.json())
            .then(data => { setPedidos(data.pedidos || []); setLoading(false); })
            .catch(err => { console.error(err); setLoading(false); });
    };

    const estados = isPlus
        ? obtenerEstados(tipoNegocio)
        : ['Pendiente', 'Entregado', 'Cancelado'];

    const getEstadoClass = (estado) => {
        switch (estado) {
            case 'Pendiente': return 'estadoPendiente';
            case 'En preparación': return 'estadoPreparacion';
            case 'Enviado': return 'estadoPreparacion';
            case 'Listo': return 'estadoListo';
            case 'Entregado': return 'estadoEntregado';
            case 'Cancelado': return 'estadoCancelado';
            default: return '';
        }
    };

    const ejecutarCambioEstado = async (idPedido, nuevoEstado, pago = null, metodoTransferencia = null) => {
        try {
            const body = { estado: nuevoEstado };
            if (pago) body.pago = pago;
            if (metodoTransferencia !== null) body.metodoTransferencia = metodoTransferencia;
            const response = await fetch(`${baseURL}/pedidoPut.php?idPedido=${idPedido}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });
            const data = await response.json();
            if (data.mensaje) {
                toast.success(data.mensaje);
                cargarPedidos();
                if (nuevoEstado === 'Entregado') {
                    cargarMesas();
                    refrescarCaja();
                }
            } else {
                toast.error(data.error || 'Error al cambiar estado');
            }
        } catch (err) {
            toast.error('Error de conexión');
        }
    };

    const cambiarEstado = (idPedido, nuevoEstado) => {
        if (nuevoEstado === 'Entregado') {
            Swal.fire({
                title: '¿Cómo pagó el cliente?',
                text: 'Seleccioná la forma de pago para registrar la venta en la caja.',
                icon: 'question',
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonColor: '#27ae60',
                denyButtonColor: '#3498db',
                cancelButtonColor: '#d33',
                confirmButtonText: '💵 Efectivo',
                denyButtonText: '💳 Transferencia',
                cancelButtonText: 'Cancelar',
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarCambioEstado(idPedido, nuevoEstado, 'efectivo', null);
                } else if (result.isDenied) {
                    const metodosDisponibles = metodos || [];
                    if (metodosDisponibles.length === 0) {
                        toast.error('No hay métodos de transferencia configurados');
                        return;
                    }
                    Swal.fire({
                        title: 'Método de transferencia',
                        input: 'select',
                        inputOptions: Object.fromEntries(metodosDisponibles.map(m => [m.nombre, m.nombre])),
                        inputPlaceholder: 'Seleccioná el método',
                        width: '22rem',
                        showCancelButton: true,
                        confirmButtonText: 'Guardar',
                        cancelButtonText: 'Cancelar',
                        confirmButtonColor: colorTema(),
                        cancelButtonColor: '#64748b',
                    }).then((r2) => {
                        if (r2.isConfirmed && r2.value) {
                            ejecutarCambioEstado(idPedido, nuevoEstado, 'transferencia', r2.value);
                        }
                    });
                }
            });
        } else if (nuevoEstado === 'Cancelado') {
            Swal.fire({
                title: '¿Cancelar pedido?',
                text: 'Una vez cancelado no se podrá cambiar el estado del pedido.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#999',
                confirmButtonText: 'Sí, cancelar pedido',
                cancelButtonText: 'Volver',
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarCambioEstado(idPedido, nuevoEstado);
                }
            });
        } else {
            ejecutarCambioEstado(idPedido, nuevoEstado);
        }
    };

    const liberarMesa = async (idMesa) => {
        try {
            const response = await fetch(`${baseURL}/mesaPut.php?idMesa=${idMesa}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ estado: 'disponible' }),
            });
            const data = await response.json();
            if (data.mensaje) {
                toast.success('Mesa liberada');
                cargarMesas();
            }
        } catch (err) {
            toast.error('Error al liberar mesa');
        }
    };

    const comandaRef = useRef(null);

        const imprimirComanda = (pedido) => {
        const productos = typeof pedido.productos === 'string'
            ? JSON.parse(pedido.productos)
            : pedido.productos;
        const mesaInfo = pedido.idMesa
            ? mesas.find(m => String(m.idMesa) === String(pedido.idMesa))
            : null;
        const nombreMesa = mesaInfo?.descripcion === 'Mesa General' ? 'Mesa General' : mesaInfo ? `Mesa ${mesaInfo.numero}` : (esTienda ? 'Local' : '—');
        const fecha = pedido.createdAt ? new Date(pedido.createdAt).toLocaleString('es-ES') : '—';
        const total = Math.round(Number(pedido.total)).toLocaleString('es-ES');

        const w = window.open('', '_blank');
        w.document.write(`<!DOCTYPE html><html><head><title>Pedido #${pedido.idPedido}</title>`);
        w.document.write(`<style>
            @page { size: 80mm auto; margin: 0; }
            body { font-family: 'Courier New', monospace; margin: 0; padding: 4mm; font-size: 11px; color: #000; }
            .comandaPrint { max-width: 80mm; margin: 0 auto; }
            .header { text-align: center; border-bottom: 2px solid #333; padding-bottom: 12px; margin-bottom: 12px; }
            .header h1 { margin: 0; font-size: 20px; letter-spacing: 1px; }
            .folio { font-size: 16px; font-weight: bold; color: #0c71cf; margin: 4px 0; }
            .header-sub { font-size: 11px; color: #888; margin: 2px 0; }
            .info-section { margin-bottom: 12px; }
            .info-row { display: flex; justify-content: space-between; padding: 4px 0; border-bottom: 1px dotted #ddd; font-size: 13px; }
            .info-row .label { font-weight: bold; color: #555; }
            .info-row .value { font-weight: 600; color: #222; }
            table { width: 100%; border-collapse: collapse; margin: 12px 0; }
            thead th { text-align: left; padding: 6px 4px; border-bottom: 2px solid #333; font-size: 11px; text-transform: uppercase; color: #555; letter-spacing: 0.5px; }
            tbody td { padding: 6px 4px; border-bottom: 1px solid #eee; vertical-align: top; }
            .cant { text-align: center; font-weight: bold; font-size: 14px; width: 35px; }
            .prod-name { font-weight: 500; }
            .prod-precio { text-align: right; font-size: 12px; color: #888; white-space: nowrap; }
            .nota-prod { display: block; font-size: 11px; color: #e67e22; font-style: italic; margin-top: 2px; }
            .total-row { display: flex; justify-content: space-between; padding: 8px 4px; border-top: 2px solid #333; margin-top: 8px; font-size: 15px; font-weight: bold; }
            .nota-global { background: #fff8e1; border-left: 4px solid #f57f17; padding: 8px 12px; margin: 12px 0; font-style: italic; font-size: 12px; border-radius: 0 4px 4px 0; }
            .nota-global .label { font-weight: bold; font-style: normal; display: block; margin-bottom: 3px; color: #f57f17; }
            .footer { text-align: center; border-top: 2px solid #333; padding-top: 12px; margin-top: 12px; }
            .footer p { margin: 0; font-size: 12px; color: #888; }
                        .footer .gracias { font-size: 14px; color: #555; margin-top: 4px; }
            .version-info { font-size: 10px; color: #aaa; margin-top: 6px; }
            .line { border-top: 1px dashed #ccc; margin: 8px 0; }
            .detalle-pago { font-size: 11px; color: #888; text-align: center; margin-top: 8px; }
        </style></head><body><div class="comandaPrint">`);

        // HEADER
        w.document.write(`<div class="header">`);
        w.document.write(`<h1>${esTienda ? 'ORDEN' : 'PEDIDO'} #${pedido.idPedido}</h1>`);
        w.document.write(`<p class="folio">${nombreMesa}</p>`);
        w.document.write(`<p class="header-sub">${fecha}</p>`);
        w.document.write(`</div>`);

        // INFO SECTION
        w.document.write(`<div class="info-section">`);
        w.document.write(`<div class="info-row"><span class="label">Cliente</span><span class="value">${pedido.nombre || '—'}</span></div>`);
        if (pedido.telefonoCliente) {
            w.document.write(`<div class="info-row"><span class="label">Tel</span><span class="value">${pedido.telefonoCliente}</span></div>`);
        }
        w.document.write(`<div class="info-row"><span class="label">Estado</span><span class="value">${pedido.estado || 'Pendiente'}</span></div>`);
        if (pedido.pago && pedido.pago !== 'Por definir' && pedido.pago !== '') {
            w.document.write(`<div class="info-row"><span class="label">Pago</span><span class="value">${pedido.pago}</span></div>`);
        }
        w.document.write(`</div>`);

        // PRODUCTS TABLE
        w.document.write(`<table><thead><tr><th>Cant</th><th>Producto</th><th>Precio</th></tr></thead><tbody>`);
        productos.forEach(prod => {
            const precio = (prod.precio * prod.cantidad).toLocaleString('es-ES');
            w.document.write(`<tr><td class="cant">${prod.cantidad}</td><td>${prod.titulo}${prod.nota ? `<span class="nota-prod">(${prod.nota})</span>` : ''}</td><td class="prod-precio">$${precio}</td></tr>`);
        });
        w.document.write(`</tbody></table>`);

        // TOTAL
        w.document.write(`<div class="total-row"><span>TOTAL</span><span>$${total}</span></div>`);

        // NOTA GLOBAL
        if (pedido.nota) {
            w.document.write(`<div class="nota-global"><span class="label">📝 Nota del pedido</span>${pedido.nota}</div>`);
        }

                // FOOTER
        w.document.write(`<div class="footer">`);
        w.document.write(`<div class="line"></div>`);
        w.document.write(`<p class="gracias">¡Gracias por tu preferencia!</p>`);
        w.document.write(`<p>${esTienda ? '¡Gracias por tu compra!' : '¡Buen provecho! 🎉'}</p>`);
        w.document.write(`<div class="version-info">v${VERSION}</div>`);
        w.document.write(`</div>`);

        w.document.write(`</div><script>window.onload=function(){window.print();window.close();}<\/script></body></html>`);
        w.document.close();
    };

    const q = busqueda.trim().toLowerCase();
    const matchBusqueda = (p) => {
        if (!q) return true;
        const nombre = (p.nombre || '').toLowerCase();
        const telefono = (p.telefono || '').toLowerCase();
        const idStr = String(p.idPedido || '');
        return nombre.includes(q) || telefono.includes(q) || idStr.includes(q);
    };
    const pedidosFiltrados = pedidos.filter(matchBusqueda);

    const pedidosWeb = pedidosFiltrados.filter(p => !p.idMesa || p.idMesa === '0' || p.idMesa === 0);
    const grupoWeb = pedidosWeb.length > 0
        ? [{ idMesa: 'web', descripcion: esTienda ? 'Pedidos' : 'Pedidos Web', numero: null, estado: 'web', esWeb: true, pedidos: pedidosWeb }]
        : [];

    const pedidosPorMesa = [
        ...grupoWeb,
        ...mesas.map(mesa => ({
            ...mesa,
            pedidos: pedidosFiltrados.filter(p => String(p.idMesa) === String(mesa.idMesa))
        })).filter(mesa => mesa.pedidos.length > 0)
    ];

    const estadosActivos = isPlus
        ? (esTienda ? ['Pendiente', 'Enviado'] : ['Pendiente', 'En preparación', 'Listo'])
        : ['Pendiente'];
    const mesasActivas = pedidosPorMesa.filter(mesa => mesa.pedidos.some(p => estadosActivos.includes(p.estado)));
    // Todas las mesas que tienen al menos un pedido finalizado (incluye mesas activas con pedidos entregados/cancelados)
    const mesasConFinalizados = pedidosPorMesa
        .map(mesa => ({ ...mesa, pedidos: mesa.pedidos.filter(p => !estadosActivos.includes(p.estado)) }))
        .filter(mesa => mesa.pedidos.length > 0);

    return (
        <div className='workerContainer'>
            <NavbarWorker />
            <ToastContainer />
            <div className='workerPedidosContent'>
                <h2>{esTienda ? 'Pedidos' : 'Pedidos por Mesa'}</h2>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap' }}>
                    <input
                        type='search'
                        placeholder='🔍 Buscar por nombre, teléfono o N° de pedido...'
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                        style={{
                            flex: 1,
                            minWidth: '250px',
                            padding: '10px 14px',
                            fontSize: '14px',
                            border: '1.5px solid #ced4da',
                            borderRadius: '8px',
                            outline: 'none',
                        }}
                    />
                    {busqueda && (
                        <button
                            onClick={() => setBusqueda('')}
                            style={{ padding: '8px 14px', background: '#e9ecef', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}
                        >
                            Limpiar
                        </button>
                    )}
                    <button className='refreshBtn' style={{ marginBottom: 0 }} onClick={() => { cargarPedidos(); cargarMesas(); }}>
                        Actualizar
                    </button>
                </div>

                {loading ? (
                    <p>Cargando pedidos...</p>
                ) : pedidosPorMesa.length === 0 ? (
                    <p className='noPedidos'>{esTienda ? 'No hay pedidos activos' : 'No hay pedidos activos en mesas'}</p>
                ) : (
                    <>
                        <div className='mesasPedidosGrid'>
                            {mesasActivas.map(mesa => (
                                <div key={mesa.idMesa} className='mesaPedidoCard'>
                                    <div className='mesaPedidoHeader'>
                                        <h3>{mesa.esWeb ? (esTienda ? 'Pedidos' : '🌐 Pedidos Web') : mesa.descripcion === 'Mesa General' ? 'Mesa General' : `Mesa ${mesa.numero}`}</h3>
                                        <span className={`mesaEstado ${mesa.estado}`}>{mesa.esWeb ? 'WEB' : mesa.estado}</span>
                                    </div>
                                    {mesa.pedidos.filter(p => estadosActivos.includes(p.estado)).sort((a, b) => b.idPedido - a.idPedido).map(pedido => {
                                        const productos = typeof pedido.productos === 'string'
                                            ? JSON.parse(pedido.productos)
                                            : pedido.productos;
                                        return (
                                            <div key={pedido.idPedido} className='pedidoItem'>
                                                <div className='pedidoHeader'>
                                                    <span>Pedido #{pedido.idPedido}</span>
                                                    <span className={getEstadoClass(pedido.estado)}>{pedido.estado}</span>
                                                </div>
                                                {pedido.nombre && (
                                                    <p className='pedidoCliente'>👤 Cliente: <strong>{pedido.nombre}</strong></p>
                                                )}
                                                {pedido.trabajadorNombre && (
                                                    <p style={{ fontSize: '13px', color: '#6c757d', margin: '2px 0' }}>🍴 Atendió: <strong>{pedido.trabajadorNombre}</strong></p>
                                                )}
                                                {pedido.telefonoCliente && (
                                                    <p style={{ fontSize: '13px', color: '#6c757d', margin: '2px 0' }}>📞 Teléfono: <strong>{pedido.telefonoCliente}</strong></p>
                                                )}
                                                {mesa.esWeb && (
                                                    <div className='pedidoInfoWeb'>
                                                        {pedido.telefono && (
                                                            <p>📞 Teléfono: <a href={`tel:${pedido.telefono}`}>{pedido.telefono}</a> · <a href={`https://wa.me/${pedido.telefono.replace(/\D/g, '')}`} target='_blank' rel='noopener noreferrer'>WhatsApp</a></p>
                                                        )}
                                                        {pedido.email && (
                                                            <p>✉️ Email: <a href={`mailto:${pedido.email}`}>{pedido.email}</a></p>
                                                        )}
                                                        {pedido.entrega && (
                                                            <p>🚚 Entrega: <strong>{pedido.entrega}</strong></p>
                                                        )}
                                                        {pedido.pago && pedido.pago !== 'Por definir' && (
                                                            <p>💳 Pago: <strong>{pedido.pago}</strong></p>
                                                        )}
                                                        {pedido.codigo && (
                                                            <p>🏷️ Código: <strong>{pedido.codigo}</strong></p>
                                                        )}
                                                    </div>
                                                )}
                                                <ul className='pedidoProductos'>
                                                    {productos.map((prod, i) => (
                                                        <li key={i}>
                                                            {prod.cantidad}x {prod.titulo} - {moneda} {String(prod.precio * prod.cantidad).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                            {prod.nota && <span className='prodNota'>({prod.nota})</span>}
                                                        </li>
                                                    ))}
                                                </ul>
                                                <div className='pedidoTotal'>
                                                    Total: {moneda} {String(Math.round(Number(pedido.total))).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                </div>
                                                {pedido.nota && <p className='pedidoNota'>Nota: {pedido.nota}</p>}
                                                                                                <button className='btnImprimirComanda' onClick={() => imprimirComanda(pedido)} title="Imprimir comanda">
                                                    🖨️ Comanda
                                                </button>
                                                {pedido.estado === 'Entregado' ? (
                                                    <div className='pedidoEntregado'>Pedido entregado</div>
                                                ) : pedido.estado === 'Cancelado' ? (
                                                    <div className='pedidoCancelado'>Pedido cancelado</div>
                                                ) : (
                                                    <div className='pedidoAcciones'>
                                                        {estados.map(est => (
                                                            <button
                                                                key={est}
                                                                className={`estadoBtn ${pedido.estado === est ? 'estadoBtnActivo' : ''}`}
                                                                onClick={() => cambiarEstado(pedido.idPedido, est)}
                                                                disabled={pedido.estado === est}
                                                            >
                                                                {est}
                                                            </button>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                        {mesasActivas.length > 0 && mesasConFinalizados.length > 0 && (
                            <div className='mesasDivisor'>
                                <span>Entregados / Cancelados</span>
                            </div>
                        )}
                        {mesasConFinalizados.length > 0 && (
                            <div className='mesasPedidosGrid'>
                                {mesasConFinalizados.map(mesa => (
                                    <div key={mesa.idMesa} className='mesaPedidoCard mesaFinalizada'>
                                        <div className='mesaPedidoHeader'>
                                            <h3>{mesa.esWeb ? (esTienda ? 'Pedidos' : '🌐 Pedidos Web') : mesa.descripcion === 'Mesa General' ? 'Mesa General' : `Mesa ${mesa.numero}`}</h3>
                                            <span className={`mesaEstado ${mesa.estado}`}>{mesa.esWeb ? 'WEB' : mesa.estado}</span>
                                        </div>
                                        {mesa.pedidos.sort((a, b) => b.idPedido - a.idPedido).map(pedido => {
                                            const productos = typeof pedido.productos === 'string'
                                                ? JSON.parse(pedido.productos)
                                                : pedido.productos;
                                            return (
                                                <div key={pedido.idPedido} className='pedidoItem'>
                                                    <div className='pedidoHeader'>
                                                        <span>Pedido #{pedido.idPedido}</span>
                                                        <span className={getEstadoClass(pedido.estado)}>{pedido.estado}</span>
                                                    </div>
                                                    {pedido.nombre && (
                                                        <p className='pedidoCliente'>👤 Cliente: <strong>{pedido.nombre}</strong></p>
                                                    )}
                                                    {mesa.esWeb && (
                                                        <div className='pedidoInfoWeb'>
                                                            {pedido.telefono && (
                                                                <p>📞 Teléfono: <a href={`tel:${pedido.telefono}`}>{pedido.telefono}</a> · <a href={`https://wa.me/${pedido.telefono.replace(/\D/g, '')}`} target='_blank' rel='noopener noreferrer'>WhatsApp</a></p>
                                                            )}
                                                            {pedido.email && (
                                                                <p>✉️ Email: <a href={`mailto:${pedido.email}`}>{pedido.email}</a></p>
                                                            )}
                                                            {pedido.entrega && (
                                                                <p>🚚 Entrega: <strong>{pedido.entrega}</strong></p>
                                                            )}
                                                            {pedido.pago && pedido.pago !== 'Por definir' && (
                                                                <p>💳 Pago: <strong>{pedido.pago}</strong></p>
                                                            )}
                                                            {pedido.codigo && (
                                                                <p>🏷️ Código: <strong>{pedido.codigo}</strong></p>
                                                            )}
                                                        </div>
                                                    )}
                                                    <ul className='pedidoProductos'>
                                                        {productos.map((prod, i) => (
                                                            <li key={i}>
                                                                {prod.cantidad}x {prod.titulo} - {moneda} {String(prod.precio * prod.cantidad).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                                {prod.nota && <span className='prodNota'>({prod.nota})</span>}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <div className='pedidoTotal'>
                                                        Total: {moneda} {String(Math.round(Number(pedido.total))).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                    </div>
                                                    {pedido.nota && <p className='pedidoNota'>Nota: {pedido.nota}</p>}
                                                                                                        <button className='btnImprimirComanda' onClick={() => imprimirComanda(pedido)} title="Imprimir comanda">
                                                        🖨️ Comanda
                                                    </button>
                                                    {pedido.estado === 'Entregado' ? (
                                                        <div className='pedidoEntregado'>Pedido entregado</div>
                                                    ) : (
                                                        <div className='pedidoCancelado'>Pedido cancelado</div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                        {mesa.estado === 'ocupada' && mesa.descripcion !== 'Mesa General' && (
                                            <button className='liberarMesaBtn' onClick={() => liberarMesa(mesa.idMesa)}>
                                                Liberar Mesa
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
